import styled from 'styled-components'
import StatusLabelBase from 'components/status-label'

export const StatusLabel = styled(StatusLabelBase)`
    align-self: unset;
`